import { Skeleton } from '@mui/material';
import clsx from 'clsx';

export const CardSkeleton = ({ colorClassName }: { colorClassName: string }) => {
    return (
        <div>
            {/* Image */}
            <Skeleton
                component={'div'}
                variant="rectangular"
                //Make height auto to override MUI's prefered height
                className={clsx('h-auto w-full aspect-[calc(16/9)] rounded-xl', colorClassName)}
            />
            <div className="mt-4">
                {/* Category */}
                <Skeleton
                    component={'div'}
                    variant="rectangular"
                    className={clsx('h-8 w-32 rounded-xl', colorClassName)}
                />
                {/* Date */}
                <Skeleton variant="text" className={clsx('w-48 h-5 rounded-md my-4', colorClassName)} />
                {/* Title */}
                <Skeleton variant="text" className={clsx('h-10 w-64 rounded-xl my-2', colorClassName)} />
                {/* Description */}
                <Skeleton variant="text" className={clsx('h-5 rounded-md', colorClassName)} />
                <Skeleton variant="text" className={clsx('h-5 rounded-md', colorClassName)} />
            </div>
        </div>
    );
};

export const SkeletonGrid = ({ count }: { count: number }) => {
    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-12 mt-8">
            {Array(count)
                .fill(0)
                .map((_, id) => (
                    <CardSkeleton colorClassName="bg-neutral-200" key={id} />
                ))}
        </div>
    );
};
